import { render } from "./StickyBottom.vue?vue&type=template&id=677db4ba"
import script from "./StickyBottom.vue?vue&type=script&lang=js"
export * from "./StickyBottom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/suivi-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__